import { render } from "./TableBodyLoader.vue?vue&type=template&id=f1cf49c2&scoped=true"
import script from "./TableBodyLoader.vue?vue&type=script&lang=js"
export * from "./TableBodyLoader.vue?vue&type=script&lang=js"

import "./TableBodyLoader.vue?vue&type=style&index=0&id=f1cf49c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cf49c2"]])

export default __exports__